import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function useExerciseMap() {
  const [exMap, setExMap] = useState({});
  useEffect(() => {
    api.get("/exercises").then((r) => {
      const m = {};
      r.data.forEach((e) => { m[e.id] = e; });
      setExMap(m);
    });
  }, []);
  return exMap;
}
